import { Toolbar } from 'components/Toolbar';
import type { ContractChangeStatusEnum } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { cnMixSpace } from 'uikit';

import type { MutableRefObject } from 'react';
import type React from 'react';
import { useCallback, useMemo } from 'react';

import { EditAgreement } from '../EditAgreement';
import { RemoveAgreement } from '../RemoveAgreement';
import { UploadAgreement } from '../UploadAgreement';

interface IAgreementFormToolbar {
    currentContractId: number;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
    currentAgreementId: number;
    refreshProject: () => void;
    needUpdateCurrentPriceList?: boolean;
    needUpdatePriceListHandler?: (nextState: boolean) => void;
    currentAgreementStatus?: ContractChangeStatusEnum;
    rulesAccess?: IUseAccess['additionalAgreement'];
    agreementTableApiRef: MutableRefObject<{ refreshCurrentTable: (skipCheckedReset?: boolean) => void } | undefined>;
    disabledUnloadButton?: boolean;
}

export const AgreementFormToolbar: React.FC<IAgreementFormToolbar> = (props) => {
    const {
        currentContractId,
        disabledByStatus,
        currentAgreementId,
        refreshProject,
        needUpdateCurrentPriceList,
        needUpdatePriceListHandler,
        isDisabledByProjectStatus,
        isDisabledByContractStatus,
        currentAgreementStatus,
        rulesAccess,
        agreementTableApiRef,
        disabledUnloadButton,
    } = props;

    const removeBtnStyles = useMemo(
        () => (disabledByStatus ? {} : { color: 'var(--color-typo-alert)', borderColor: 'var(--color-typo-alert)' }),
        [disabledByStatus],
    );

    const refreshHandler = useCallback(() => {
        agreementTableApiRef?.current?.refreshCurrentTable(true);
    }, [agreementTableApiRef]);

    return (
        <Toolbar fullLine flex>
            <EditAgreement
                currentContractId={currentContractId}
                currentAgreementId={currentAgreementId}
                currentAgreementStatus={currentAgreementStatus}
                refreshHandler={refreshHandler}
                className={cnMixSpace({ mR: 's' })}
                needUpdateCurrentPriceList={needUpdateCurrentPriceList}
                needUpdatePriceListHandler={needUpdatePriceListHandler}
                isDisabledByProjectStatus={isDisabledByProjectStatus}
                isDisabledByContractStatus={isDisabledByContractStatus}
                rulesAccessDisabled={!rulesAccess?.canEdit}
            />
            <UploadAgreement
                currentAgreementId={currentAgreementId}
                currentAgreementStatus={currentAgreementStatus}
                className={cnMixSpace({ mR: 's' })}
                rulesAccessDisabled={!rulesAccess?.canUploadToExcel}
                disabledUnloadButton={disabledUnloadButton}
            />
            <RemoveAgreement
                currentAgreementId={currentAgreementId}
                currentAgreementStatus={currentAgreementStatus}
                refreshHandler={refreshHandler}
                refreshProject={refreshProject}
                isDisabled={disabledByStatus || isDisabledByProjectStatus || isDisabledByContractStatus}
                styles={removeBtnStyles}
                rulesAccessDisabled={!rulesAccess?.canDelete}
            />
        </Toolbar>
    );
};

AgreementFormToolbar.displayName = 'AgreementFormToolbar';
